import { Action } from '@ngrx/store';

export enum RenewalsModuleActionTypes {
  FetchRenewalsQueue = '[Renewals] Fetch Renewals Queue',
  FetchRenewalsQueueSuccess = '[Renewals] Fetch Renewals Queue Success',
  FetchRenewalsQueueFailure = '[Renewals] Fetch Renewals Queue Failure',
  SetOriginalQuoteRequestId = '[Renewals] Set Original Quote Request Id',
}

export class FetchRenewalsQueue implements Action {
  readonly type = RenewalsModuleActionTypes.FetchRenewalsQueue;
}

export class FetchRenewalsQueueSuccess implements Action {
  readonly type = RenewalsModuleActionTypes.FetchRenewalsQueueSuccess;
  constructor() {}
}

export class FetchRenewalsQueueFailure implements Action {
  readonly type = RenewalsModuleActionTypes.FetchRenewalsQueueFailure;
  constructor(public error: any) {}
}

export class SetOriginalQuoteRequestId implements Action {
  readonly type = RenewalsModuleActionTypes.SetOriginalQuoteRequestId;
  constructor(public originalQuoteRequestId: number | null) {}
}

export type RenewalsModuleActions = SetOriginalQuoteRequestId | FetchRenewalsQueue | FetchRenewalsQueueSuccess | FetchRenewalsQueueFailure;
